var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaterialIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.867 1.672 4.125 3.075c-.863.322-1.567 1.342-1.567 2.265v5.572c0 .885.585 2.048 1.297 2.58L7.08 15.9c1.057.795 2.797.795 3.855 0l3.225-2.408c.713-.532 1.297-1.695 1.297-2.58V5.34c0-.923-.705-1.943-1.567-2.265l-3.742-1.403c-.638-.232-1.658-.232-2.28 0z",
    stroke: "#9AA0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.19h-.097a1.317 1.317 0 0 1-1.268-1.32c0-.728.593-1.32 1.32-1.32.728 0 1.32.593 1.32 1.32A1.323 1.323 0 0 1 9 8.19zM7.508 10.29c-.72.48-.72 1.268 0 1.748.817.547 2.16.547 2.977 0 .72-.48.72-1.268 0-1.748-.81-.547-2.152-.547-2.977 0z",
    stroke: "#9AA0B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialIcon);
export default __webpack_public_path__ + "static/media/material_icon.9b9708dadf4d5df1e7de40147c097b01.svg";
export { ForwardRef as ReactComponent };